import config from "./config";

const Logout = async (email) => {
  try {
    const response = await config.post("/azure/logout", { email });
    return response.data;
  } catch (error) {
    console.log("Error: ", error);
  }
};

const IsAdmin = async (email, token) => {
  try {
    const response = await config.post("/api/is-admin", { search: email }, {
      // headers: {
      //   Authorization: `Bearer ${token}`
      // }
    });
    return response.data;
  } catch (error) {
    console.log("Error: ", error);
  }
}

export const FetchUsers = async (searchQuery) => {
  const { data } = await config.post("/api/users", { search: searchQuery }, {
    // headers: {
    //   Authorization: `Bearer ${token}`
    // }
  })
  return data;
}

export  const tokenValidationApi = async (payload) => {
  const  data  = await config.post("/azure/validate-token",payload)
  return data;
};

export const refreshTokenApi = async (payload, token) => {
  try {
    const response = await config.post('/azure/refresh-token', payload, {
      // headers: {
      //   Authorization: `Bearer ${token}`
      // }
    });
    return response.data;
  } catch (error) {
    console.log("Error: ", error);
    window.location.href = "/login";
  }
};

export const LogoutApi = async (token) => {
  try {
    const payload={ app_type: "sso" };
    const response = await config.post(`/azure/logout`, payload,{
      // headers: {
      //   Authorization: `Bearer ${token}`
      // }
    });
    return response.data;
  } catch (error) {
    console.log("Error: ", error);
  }
};
// ==============================
// NEW: getMyDetails WITH auto‑logout on error
// ==============================
export const getMyDetails = async () => {
  try {
    const response = await config.get("/api/user/me");
    return response.data;
  } catch (error) {
    console.error("getMyDetails error:", error);

    // If it's a 401 (Unauthorized), skip the auto‑logout/redirect
    const status = error?.response?.status;
    if (status === 401) {
      // you might choose to just re‑throw it so the caller can handle it
      throw error;
    }

    // For any other error, perform auto‑logout + redirect
    try {
      await LogoutApi();
    } catch (logoutErr) {
      console.error("Error during auto-logout:", logoutErr);
    }

    window.location.href = "/login";
  }
};

export default {
  Logout,
  IsAdmin
};
